












































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class EmploymentOpportunities extends Vue {}
